import "./index.scss";
import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";
import IGFly from "../../../assets/img/Featured/fly-tap-pay-tall.png";
import IGOnDemand from "../../../assets/img/Featured/app-ondemand-food.png";
import IGQuickPay from "../../../assets/img/Featured/app-qr-quickpay-tall.png";
import Reserve from "../../../assets/img/Featured/app-reserve2.png";


const PoolsideDiningPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return (
      <div className="page poolsideDiningPage">
        <Header />
        <div className="page-header">Residential Building</div>
        <div className="text-wrapper">
          <div className="top">
            <div className="topic-header">Poolside Dining</div>
            <HorizontalLine />
          </div>
          <div className="std-text">
            Delight residents with food and beverage at-a-click 
            ordering delivered wherever they are.{'\n\n'}

            Enhance the poolside experience with fast, easy, 
            mobile ordering and payment to drive increased 
            order volume, improve check size and grow F&B 
            revenue.
          </div>
        </div>

        <FeaturedSolutions>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Residential Building - Poolside Dining", "IG Fly");
              addFlow("IG Fly");
              navigate("/solutions/ig-fly");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG Fly
            </div>
            <img src={IGFly} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Residential Building - Poolside Dining", "IG OnDemand");
              addFlow("IG OnDemand");
              navigate("/solutions/ig-on-demand");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG OnDemand
            </div>
            <img src={IGOnDemand} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Residential Building - Poolside Dining", "IG Quick Pay");
              addFlow("IG Quick Pay");
              navigate("/solutions/ig-quick-pay");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG Quick Pay
            </div>
            <img src={IGQuickPay} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Residential Building - Poolside Dining", "Reserve");
              addFlow("Reserve");
              navigate("/solutions/reserve");
            }}
          >
            <div className="item-head">
              <LogoMini />
              Reserve
            </div>
            <img src={Reserve} alt="" />
          </div>
        </FeaturedSolutions>
      </div>
    );
}

export default PoolsideDiningPage;